const MAX_EDGE = 2048;
const KEEP_ORIGINAL_UNDER_BYTES = 3 * 1024 * 1024;

function loadImage(file: File): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const image = new Image();
    image.decoding = "async";
    image.onload = () => {
      URL.revokeObjectURL(url);
      resolve(image);
    };
    image.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("FILE_INVALID"));
    };
    image.src = url;
  });
}

function canvasBlob(canvas: HTMLCanvasElement): Promise<Blob> {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => blob ? resolve(blob) : reject(new Error("FILE_INVALID")), "image/jpeg", 0.9);
  });
}

export async function prepareAvatarUpload(file: File): Promise<File> {
  const image = await loadImage(file);
  const largestEdge = Math.max(image.naturalWidth, image.naturalHeight);
  const isUploadReady = largestEdge <= MAX_EDGE
    && file.size <= KEEP_ORIGINAL_UNDER_BYTES
    && ["image/jpeg", "image/png", "image/webp"].includes(file.type);
  if (isUploadReady) return file;

  const scale = Math.min(1, MAX_EDGE / largestEdge);
  const canvas = document.createElement("canvas");
  canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
  canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
  const context = canvas.getContext("2d");
  if (!context) throw new Error("FILE_INVALID");
  context.drawImage(image, 0, 0, canvas.width, canvas.height);
  const blob = await canvasBlob(canvas);
  return new File([blob], "avatar-upload.jpg", { type: "image/jpeg", lastModified: file.lastModified });
}
